export default __webpack_public_path__ + "static/media/potatoChips.781e229c.jpg";